import { applyMiddleware, combineReducers, compose, createStore } from "redux";
import { toggleMenu } from "./reducers/PostsReducer";
import thunk from "redux-thunk";
import { AuthReducer } from "./reducers/AuthReducer";
import { ChatReducer } from "./reducers/ChatReducer";
import { MsgReducer } from "./reducers/MsgReducer";
import { MinutesReducer } from "./minutes/reducers";

import templatesReducer from "./features/templates/templatesReducer";
import eventConfigReducer from "./features/eventConfig/eventConfigReducer";
import outboxReducer from "./features/outbox/outboxReducer";
import uiReducer from "./features/ui/uiReducer";

import calendarReducer from "./features/calendar/calendarReducer.js";
import appointmentsReducer from "./features/appointments/appointmentsReducer.js";
import agendasReducer from "./features/agendas/agendasReducer.js";
import { noteReducer } from "./features/dealProgress/noteReducer.js";
const middleware = applyMiddleware(thunk);

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

const reducers = combineReducers({
  sideMenu: toggleMenu,
  auth: AuthReducer,
  chat: ChatReducer,
  msg: MsgReducer,
  minutes: MinutesReducer,
  templates: templatesReducer,
  eventConfig: eventConfigReducer,
  outbox: outboxReducer,
  calendar: calendarReducer,
  appointments: appointmentsReducer,
  agendas: agendasReducer,
  ui: uiReducer,
  notes: noteReducer,
});

export const store = createStore(reducers, composeEnhancers(middleware));
